import React, { useEffect, useState } from "react"

import { SplashScreen } from "@capacitor/splash-screen"
import { Network } from "@capacitor/network"
import { settings } from "@/settings"
import { SafeArea } from "capacitor-plugin-safe-area"
import { Outlet, useLocation } from "react-router"
import NoInternetConnectionPage from "./dashboard/NoInternetConnectionPage"
import { usePushNotifications } from "@/hooks/usePushNotifications"
import { PushTokenContext } from "./dashboard/contexts"
import { CapacitorSwipeBackPlugin } from "capacitor-swipe-back-plugin"

const AppUrlListener: React.FC<any> = () => {
  return null
}

export const NativeLayout: React.FC = () => {
  if (!settings.IS_NATIVE_APP) {
    return (
      <PushTokenContext.Provider value={null}>
        <Outlet />
      </PushTokenContext.Provider>
    )
  }

  const permissionStatus = usePushNotifications()
  const location = useLocation()
  const [isConnected, setIsConnected] = useState(true)

  useEffect(() => {
    if (!settings.IS_ANDROID) {
      SplashScreen.show({
        showDuration: 2000,
        autoHide: true
      })
    }

    if (settings.IS_IOS) {
      CapacitorSwipeBackPlugin.enable()
    }
  }, [])

  useEffect(() => {
    Network.addListener("networkStatusChange", (status) => {
      console.log("Network status changed", status)
      if (!status.connected) {
        setIsConnected(false)
      } else {
        setIsConnected(true)
      }
    })
  }, [])

  useEffect(() => {
    const updateSafeAreaInsets = async () => {
      const safeAreaData = await SafeArea.getSafeAreaInsets()
      const { insets } = safeAreaData
      for (const [key, value] of Object.entries(insets)) {
        document.documentElement.style.setProperty(`--safe-area-inset-${key}`, `${value}px`)
      }

      console.log("Set initial safe area insets", safeAreaData)
    }

    updateSafeAreaInsets()

    SafeArea.addListener("safeAreaChanged", (data) => {
      const { insets } = data
      for (const [key, value] of Object.entries(insets)) {
        document.documentElement.style.setProperty(`--safe-area-inset-${key}`, `${value}px`)
        console.log("Updated safe area insets", data)
      }
    })
  }, [])

  useEffect(() => {
    console.log("Current route:", location.pathname + location.search)
  }, [location])

  if (!isConnected) {
    return <NoInternetConnectionPage isConnected={isConnected} />
  }

  return (
    <PushTokenContext.Provider value={permissionStatus}>
      <AppUrlListener />
      <Outlet />
    </PushTokenContext.Provider>
  )
}
